import React, { ReactNode, useState, useContext, useEffect } from "react";
import { TimezoneModel } from "../models/TimezoneModel";
import { ItemCategoryModel } from "../models/ItemCategoryModel";
import timezoneService from "../services/timezoneService";
import itemService from "../services/itemService";
import { SystemContentModel } from "../models/SystemContentModel";
import systemContentService from "../services/systemContentService";

interface ReferenceDataContextType {
    timezones: TimezoneModel[] | null;
    categories: ItemCategoryModel[] | null;
    commissionTerms: SystemContentModel | null;
    loading: boolean;
}

const ReferenceDataContext = React.createContext<ReferenceDataContextType | undefined>(undefined)

interface ReferenceDataProviderProps {
    children: ReactNode;
}

export const ReferenceDataProvider = ({ children }: ReferenceDataProviderProps) => {

    const [timezones, setTimezones] = useState<TimezoneModel[] | null>(null);
    const [categories, setCategories] = useState<ItemCategoryModel[] | null>(null);
    const [commissionTerms, setCommissionTerms] = useState<SystemContentModel | null>(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadReferenceData = async () => {
            try {
                const [tz, cats, terms] = await Promise.all([
                    timezoneService.getTimezones(),
                    itemService.getAllCategories(),
                    systemContentService.getCommissionTermsContent()
                ]);
                setTimezones(tz);
                setCategories(cats);
                setCommissionTerms(terms);
            } catch (err) {
                console.error('Failed to load reference data', err);
            } finally {
                setLoading(false);
            }
        };

        loadReferenceData();
    }, []);
    
    return (
        <ReferenceDataContext.Provider value={{ timezones, categories, commissionTerms, loading }}>
            {children}
        </ReferenceDataContext.Provider>
    );

}

export const useReferenceDataContext = (): ReferenceDataContextType => {
    const context = useContext(ReferenceDataContext);
    if (!context) {
        throw new Error('useReferenceDataContext must be used within ReferenceDataProvider');
    }
    return context;
}
